import * as React from 'react';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { getAccountOrders } from '@/services.ts';
import { OrdersList } from '@/components/molecules/OrdersList';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { ACCOUNT_STALE_TIME_5_MINS } from '@/config';
import { LoadingScreen } from '@/components/molecules/LoadingScreen.tsx';
import { ErrorComponent } from '@/components/molecules/ErrorComponent.tsx';

const ordersQueryOptions = (isServer: boolean) => queryOptions({
  queryKey: ['account', 'orders'],
  queryFn: () => {
    if(isServer) {
      return null;
    }
    return getAccountOrders();
  },
  retry: false,
  staleTime: ACCOUNT_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/account/orders')({
  loader: async({ context }) => {
    return context.queryClient?.ensureQueryData(ordersQueryOptions(context.isServer));
  },
  pendingComponent: LoadingScreen,
  component: AccountOrders,
  errorComponent: ErrorComponent,
});

function AccountOrders() {
  const router = useRouter();
  const { error, data } = useSuspenseQuery(ordersQueryOptions(router.isServer));

  if(error) return(<ErrorComponent error={error}/>)
  if(data) {
    return(
      <div className="mt-8">
        <h1 className="text-4xl mb-4">My Orders</h1>
        <OrdersList orders={data} />
      </div>
    )
  }

}
